// imports section Start
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { Membershipdata } from "../../assets/Griddata"; // Import dataset
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { CircularProgress } from "@mui/material";
import { externalgetApi } from "../../services/external/externalApis";
import { SETTINGS_API_11 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { currencyFormatLKR } from "../../../src/utils/common/CurrencyFormat";
import SearchAppBar from "../../components/common/search";
// imports section End

function ViewMemberships() {
  // Hooks start
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};

  // Handlers start
  const gotoMenuPage1 = () => {
    navigate("/pathToViewItems");
  };

  const gotoMenuPage2 = () => {
    navigate("/pathToGotoPage");
  };

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      MEMBERSHIPCODE: item.MEMBERSHIPCODE,
      GROUPNAME: item.GROUPNAME,
      DISCOUNT: item.DISCOUNT,
      AMOUNTFORPOINTS: currencyFormatLKR(item.AMOUNTFORPOINTS, "LKR", false),
      POINTSFORAMOUNT: item.POINTSFORAMOUNT,
      POINTSTOAMOUNT: item.POINTSTOAMOUNT,
      AMOUNTTOPOINTS: currencyFormatLKR(item.AMOUNTTOPOINTS, "LKR", false),
    }));
  };

  const rows = filteredData ? mapResultToRows(filteredData) : [];

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) => {
        return (
          item.GROUPNAME.toLowerCase().includes(searchText.toLowerCase()) ||
          item.DISCOUNT.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }, [searchText, data]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const gotToPage = () => {
    navigate("/membership");
  };

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.MEMBERSHIPCODE === id);
      if (selectedItem) {
        navigate(`/membership`, { state: { selectedItem, actionText } });
      }
    } else {
      navigate(`/membership`, { state: { selectedItem: "" } });
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (MEMBERSHIPCODE) => handleItemClick(MEMBERSHIPCODE, "Edit"),
    },
  ];

  // Handlers end

  // API calls start
  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_11, "get", {
        COMPCODE,
        LOCCODE,
        STS: CON_STATUS_ACTIVE,
      });
      setData(result);
      setFilteredRows(result);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };
  // API calls end

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Customer</Link>
                <Link underline="none">Membership</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={() => gotToPage()}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={Membershipdata.columns}
          rows={rows.map((item) => ({ ...item, id: item.MEMBERSHIPCODE }))}
          menuItems={menuItems}
          tabletitle={Membershipdata.name}
          gridid="MEMBERSHIPCODE"
        />
      )}
    </div>
  );
}

export default ViewMemberships;
